<template>
    <div id="lt-yantr-v2" class="investment-calc">
        <advertising-disclosures
            v-if="DisclosureText"
            :disclosure-text="DisclosureText"
            :disclosure-tokens="DisclosureTokens"
            class="disclosure-sec"
        />
        <div class="tab-panel">
            <ul class="tab-panel--nav">
                <li v-if="isTab1Visible == true" :class="{'active': activeTab1}">
                    <a @click="activeTab1=true, activeTab2=false, activeTab3=false, activeTab4=false">{{ tabPanel1HeaderText }}</a>
                </li>
                <li v-if="isTab2Visible == true" :class="{'active': activeTab2}">
                    <a @click="activeTab1=false, activeTab2=true, activeTab3=false, activeTab4=false">{{ tabPanel2HeaderText }}</a>
                </li>
                <li v-if="isTab3Visible == true" :class="{'active': activeTab3}">
                    <a @click="activeTab1=false, activeTab2=false, activeTab3=true, activeTab4=false">{{ tabPanel3HeaderText }}</a>
                </li>
                <li v-if="isTab4Visible == true" :class="{'active': activeTab4}">
                    <a @click="activeTab1=false, activeTab2=false, activeTab3=false, activeTab4=true">{{ tabPanel4HeaderText }}</a>
                </li>
            </ul>
            <div class="tab-panel--content">
                <compound
                    v-show="isTab1Visible == true && activeTab1"
                    :label-initial-amount="tab1LabelInitialAmount"
                    :initial-amount="tab1InitialAmount"
                    :years-to-grow="tab1YearsToGrow"
                    :label-years-to-grow="tab1LabelYearsToGrow"
                    :label-rate-return="tab1LabelRateReturn"
                    :rate-return="tab1RateReturn"
                    :rate-return-tooltip="tab1RateReturnTooltip"
                    :is-pi-chart-visible="isTab1PiChartVisible"
                    :is-bar-chart-visible="isTab1BarChartVisible"
                    :is-amortization-table-visible="isTab1AmortizationTableVisible"
                    :label-additional-contribution="tab1LabelAdditionalContribution"
                    :additional-contribution="tab1AdditionalContribution"
                    :label-compound-interval="tab1LabelCompoundInterval"
                    :compound-interval="tab1CompoundInterval"
                    :compound-interval-tooltip="tab1CompoundIntervalTooltip"
                    :right-section-header-text="tab1RightSectionHeaderText"
                    :content-header-text="tab1ContentHeaderText"
                    :right-section-graph-title="tab1RightSectionGraphTitle"
                    :right-section-graph-title-on-mobile="tab1RightSectionGraphTitleOnMobile"
                    :right-section-bar-chart-title="tab1RightSectionBarChartTitle"
                    :right-section-bar-chart-title-on-mobile="tab1RightSectionBarChartTitleOnMobile"
                    :graph-contribution-option1="tab1GraphContributionOption1"
                    :graph-contribution-option2="tab1GraphContributionOption2"
                    :graph-contribution-option3="tab1GraphContributionOption3"
                    :submit-button-text="tab1SubmitButtonText"
                    class="tab-panel--compound"
                />
                <investment
                    v-show="isTab2Visible == true && activeTab2"
                    :label-investment-goal="labelInvestmentGoal"
                    :investment-goal="investmentGoal"
                    :label-initial-investment="labelInitialInvestment"
                    :initial-investment="initialInvestment"
                    :is-pi-chart-visible="isTab2PiChartVisible"
                    :is-bar-chart-visible="isTab2BarChartVisible"
                    :is-amortization-table-visible="isTab2AmortizationTableVisible"
                    :label-years-to-grow="tab2LabelYearsToGrow"
                    :years-to-grow="tab2YearsToGrow"
                    :label-additional-contribution="tab2LabelAdditionalContribution"
                    :additional-contribution="tab2AdditionalContribution"
                    :label-rate-return="tab2LabelRateReturn"
                    :rate-return="tab2RateReturn"
                    :rate-return-tooltip="tab2RateReturnTooltip"
                    :label-compound-interval="tab2LabelCompoundInterval"
                    :compound-interval="tab2CompoundInterval"
                    :compound-interval-tooltip="tab2CompoundIntervalTooltip"
                    :right-section-header-text="tab2RightSectionHeaderText"
                    :right-section-header-text2="tab2RightSectionHeaderText2"
                    :content-header-text="tab2ContentHeaderText"
                    :right-section-graph-title="tab2RightSectionGraphTitle"
                    :right-section-graph-title-on-mobile="tab2RightSectionGraphTitleOnMobile"
                    :right-section-bar-chart-title="tab2RightSectionBarChartTitle"
                    :right-section-bar-chart-title-on-mobile="tab2RightSectionBarChartTitleOnMobile"
                    :graph-contribution-option1="tab2GraphContributionOption1"
                    :graph-contribution-option2="tab2GraphContributionOption2"
                    :graph-contribution-option3="tab2GraphContributionOption3"
                    :submit-button-text="tab2SubmitButtonText"
                    class="tab-panel--compound"
                />
                <savings
                    v-show="isTab3Visible == true && activeTab3"
                    :initial-deposit="initialDeposit"
                    :label-initial-deposit="labelInitialDeposit"
                    :is-pi-chart-visible="isTab3PiChartVisible"
                    :is-bar-chart-visible="isTab3BarChartVisible"
                    :is-amortization-table-visible="isTab3AmortizationTableVisible"
                    :label-years-to-save="tab3LabelYearsToSave"
                    :years-to-save="tab3YearsToSave"
                    :label-additional-contribution="tab3LabelAdditionalContribution"
                    :additional-contribution="tab3AdditionalContribution"
                    :label-annual-interest-rate="tab3LabelAnnualInterestRate"
                    :annual-interest-rate="tab3AnnualInterestRate"
                    :annual-interest-rate-tooltip="tab3AnnualInterestRateTooltip"
                    :label-compound-interval="tab3LabelCompoundInterval"
                    :compound-interval="tab3CompoundInterval"
                    :compound-interval-tooltip="tab3CompoundIntervalTooltip"
                    :right-section-header-text="tab3RightSectionHeaderText"
                    :content-header-text="tab3ContentHeaderText"
                    :right-section-graph-title="tab3RightSectionGraphTitle"
                    :right-section-graph-title-on-mobile="tab3RightSectionGraphTitleOnMobile"
                    :right-section-bar-chart-title="tab3RightSectionBarChartTitle"
                    :right-section-bar-chart-title-on-mobile="tab3RightSectionBarChartTitleOnMobile"
                    :graph-contribution-option1="tab3GraphContributionOption1"
                    :graph-contribution-option2="tab3GraphContributionOption2"
                    :graph-contribution-option3="tab3GraphContributionOption3"
                    :submit-button-text="tab3SubmitButtonText"
                    class="tab-panel--compound"
                />
                <retirement
                    v-show="isTab4Visible == true && activeTab4"
                    :label-initial-savings="tab4LabelInitialSavings"
                    :initial-savings="tab4InitialSavings"
                    :initial-savings-tooltip="tab4InitialSavingsTooltip"
                    :label-retirement-age="tab4LabelRetirementAge"
                    :retirement-age="tab4RetirementAge"
                    :retirement-age-tooltip="tab4RetirementAgeTooltip"
                    :label-rate-return="tab4LabelRateReturn"
                    :rate-return="tab4RateReturn"
                    :rate-return-tooltip="tab4RateReturnTooltip"
                    :label-current-age="tab4LabelCurrentAge"
                    :is-pi-chart-visible="isTab4PiChartVisible"
                    :is-bar-chart-visible="isTab4BarChartVisible"
                    :is-amortization-table-visible="isTab4AmortizationTableVisible"
                    :label-additional-contribution="tab4LabelAdditionalContribution"
                    :additional-contribution="tab4AdditionalContribution"
                    :label-compound-interval="tab4LabelCompoundInterval"
                    :compound-interval="tab4CompoundInterval"
                    :compound-interval-tooltip="tab4CompoundIntervalTooltip"
                    :right-section-header-text="tab4RightSectionHeaderText"
                    :content-header-text="tab4ContentHeaderText"
                    :right-section-graph-title="tab4RightSectionGraphTitle"
                    :right-section-graph-title-on-mobile="tab4RightSectionGraphTitleOnMobile"
                    :right-section-bar-chart-title="tab4RightSectionBarChartTitle"
                    :right-section-bar-chart-title-on-mobile="tab4RightSectionBarChartTitleOnMobile"
                    :graph-contribution-option1="tab4GraphContributionOption1"
                    :graph-contribution-option2="tab4GraphContributionOption2"
                    :graph-contribution-option3="tab4GraphContributionOption3"
                    :submit-button-text="tab4SubmitButtonText"
                    :currentAge="tab4CurrentAge"
                    class="tab-panel--retirement"
                />
            </div>
        </div>
    </div>
</template>
<script>
    import AdvertisingDisclosures from '~/components/v2/advertising-disclosures.vue';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import Compound from './components/compound.vue';
    import Investment from './components/investment.vue';
    import Savings from './components/savings.vue';
    import Retirement from './components/retirement.vue';

    export default {
        props: {
            tab1LabelInitialAmount: {
                default: 'Initial Amount',
            },
            tab1InitialAmount: {
                default: 10000,
            },
            labelInvestmentGoal: {
                default: 'Investment Goal',
            },
            investmentGoal: {
                default: 20000,
            },
            labelInitialInvestment: {
                default: 'Initial Investment',
            },
            initialInvestment: {
                default: 10000,
            },
            labelInitialDeposit: {
                default: 'Initial Deposit',
            },
            initialDeposit: {
                default: 10000,
            },
            tab1LabelYearsToGrow: {
                default: 'Years to Grow',
            },
            tab1YearsToGrow: {
                default: '5',
            },
            tab4LabelInitialSavings: {
                default: 'Initial Savings',
            },
            tab4InitialSavings: {
                default: 10000,
            },
            tab4InitialSavingsTooltip: {
                default: DefaultTooltip.InitialSavings,
            },
            tab4LabelRetirementAge: {
                default: 'Retirement Age',
            },
            tab4LabelCurrentAge: {
                default: 'Current Age',
            },
            tab4CurrentAge: {
                default: 60,
            },
            tab4RetirementAge: {
                default: 65,
            },
            tab4RetirementAgeTooltip: {
                default: DefaultTooltip.RetirementAge,
            },
            tab2LabelYearsToGrow: {
                default: 'Years to Grow',
            },
            tab2YearsToGrow: {
                default: '5',
            },
            tab3LabelYearsToSave: {
                default: 'Years to Save',
            },
            tab3YearsToSave: {
                default: '5',
            },
            tab1LabelAdditionalContribution: {
                default: 'Additional Contribution',
            },
            tab2LabelAdditionalContribution: {
                default: 'Additional Contribution',
            },
            tab3LabelAdditionalContribution: {
                default: 'Additional Contribution',
            },
            tab4LabelAdditionalContribution: {
                default: 'Additional Contribution',
            },
            tab1AdditionalContribution: {
                default: 200,
            },
            tab2AdditionalContribution: {
                default: 200,
            },
            tab3AdditionalContribution: {
                default: 200,
            },
            tab4AdditionalContribution: {
                default: 200,
            },
            tab1LabelRateReturn: {
                default: 'Rate of Return',
            },
            tab2LabelRateReturn: {
                default: 'Rate of Return',
            },
            tab4LabelRateReturn: {
                default: 'Rate of Return',
            },
            tab1RateReturn: {
                default: 2,
            },
            tab2RateReturn: {
                default: 2,
            },
            tab4RateReturn: {
                default: 2,
            },
            tab1RateReturnTooltip: {
                default: DefaultTooltip.RateOfReturn,
            },
            tab2RateReturnTooltip: {
                default: DefaultTooltip.RateOfReturn,
            },
            tab4RateReturnTooltip: {
                default: DefaultTooltip.RateOfReturn,
            },
            tab3LabelAnnualInterestRate: {
                default: 'Annual Interest Rate',
            },
            tab3AnnualInterestRate: {
                default: 2,
            },
            tab3AnnualInterestRateTooltip: {
                default: DefaultTooltip.AnnualInterestRate,
            },
            tab1LabelCompoundInterval: {
                default: 'Compound Interval',
            },
            tab2LabelCompoundInterval: {
                default: 'Compound Interval',
            },
            tab3LabelCompoundInterval: {
                default: 'Compound Interval',
            },
            tab4LabelCompoundInterval: {
                default: 'Compound Interval',
            },
            tab1CompoundInterval: {
                default: '12',
            },
            tab2CompoundInterval: {
                default: '12',
            },
            tab3CompoundInterval: {
                default: '12',
            },
            tab4CompoundInterval: {
                default: '12',
            },
            tab1CompoundIntervalTooltip: {
                default: DefaultTooltip.CompoundInterval,
            },
            tab2CompoundIntervalTooltip: {
                default: DefaultTooltip.CompoundInterval,
            },
            tab3CompoundIntervalTooltip: {
                default: DefaultTooltip.CompoundInterval,
            },
            tab4CompoundIntervalTooltip: {
                default: DefaultTooltip.CompoundInterval,
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Advertising Disclosure',
            },
            tabPanel1HeaderText: {
                default: 'Compound',
            },
            tabPanel2HeaderText: {
                default: 'Invest',
            },
            tabPanel3HeaderText: {
                default: 'Savings',
            },
            tabPanel4HeaderText: {
                default: 'Retirement',
            },
            tab1ContentHeaderText: {
                default: 'Compound Interest Calculator',
            },
            tab2ContentHeaderText: {
                default: 'Investments Calculator',
            },
            tab3ContentHeaderText: {
                default: 'Savings Calculator',
            },
            tab4ContentHeaderText: {
                default: 'Retirement Calculator',
            },
            isTab1Visible: {
                default: true,
            },
            isTab2Visible: {
                default: true,
            },
            isTab3Visible: {
                default: true,
            },
            isTab4Visible: {
                default: true,
            },
            isTab1PiChartVisible: {
                default: true,
            },
            isTab1BarChartVisible: {
                default: true,
            },
            isTab1AmortizationTableVisible: {
                default: true,
            },
            isTab2PiChartVisible: {
                default: true,
            },
            isTab2BarChartVisible: {
                default: true,
            },
            isTab2AmortizationTableVisible: {
                default: true,
            },
            isTab3PiChartVisible: {
                default: true,
            },
            isTab3BarChartVisible: {
                default: true,
            },
            isTab3AmortizationTableVisible: {
                default: true,
            },
            isTab4PiChartVisible: {
                default: true,
            },
            isTab4BarChartVisible: {
                default: true,
            },
            isTab4AmortizationTableVisible: {
                default: true,
            },
            tab1SubmitButtonText: {
                default: 'Update',
            },
            tab2SubmitButtonText: {
                default: 'Update',
            },
            tab3SubmitButtonText: {
                default: 'Update',
            },
            tab4SubmitButtonText: {
                default: 'Update',
            },
            tab1RightSectionHeaderText: {
                default: 'Your estimated total in',
            },
            tab2RightSectionHeaderText: {
                default: 'Estimated',
            },
            tab2RightSectionHeaderText2: {
                default: 'Your goal of ',
            },
            tab3RightSectionHeaderText: {
                default: 'Your estimated total in ',
            },
            tab4RightSectionHeaderText: {
                default: 'Estimated retirement savings at ',
            },
            tab1RightSectionGraphTitle: {
                default: 'Balance by',
            },
            tab1RightSectionGraphTitleOnMobile: {
                default: 'Compound Interest balance by',
            },
            tab2RightSectionGraphTitle: {
                default: 'Balance by',
            },
            tab2RightSectionGraphTitleOnMobile: {
                default: 'Compound Interest balance by',
            },
            tab3RightSectionGraphTitle: {
                default: 'Balance by',
            },
            tab3RightSectionGraphTitleOnMobile: {
                default: 'Compound Interest balance by',
            },
            tab4RightSectionGraphTitle: {
                default: 'Balance by',
            },
            tab4RightSectionGraphTitleOnMobile: {
                default: 'Compound Interest balance by',
            },
            tab1RightSectionBarChartTitle: {
                default: 'Growth over time',
            },
            tab1RightSectionBarChartTitleOnMobile: {
                default: 'Compound Interest growth over time',
            },
            tab2RightSectionBarChartTitle: {
                default: 'Growth over time',
            },
            tab2RightSectionBarChartTitleOnMobile: {
                default: 'Growth over time',
            },
            tab3RightSectionBarChartTitle: {
                default: 'Growth over time',
            },
            tab3RightSectionBarChartTitleOnMobile: {
                default: 'Compound Interest growth over time',
            },
            tab4RightSectionBarChartTitle: {
                default: 'Growth over time',
            },
            tab4RightSectionBarChartTitleOnMobile: {
                default: 'Compound Interest growth over time',
            },
            tab1GraphContributionOption1: {
                default: 'Starting Amount',
            },
            tab1GraphContributionOption2: {
                default: 'Total Contributions',
            },
            tab1GraphContributionOption3: {
                default: 'Total Interest Earned',
            },
            tab2GraphContributionOption1: {
                default: 'Starting Amount',
            },
            tab2GraphContributionOption2: {
                default: 'Total Contributions',
            },
            tab2GraphContributionOption3: {
                default: 'Total Interest Earned',
            },
            tab3GraphContributionOption1: {
                default: 'Starting Amount',
            },
            tab3GraphContributionOption2: {
                default: 'Total Contributions',
            },
            tab3GraphContributionOption3: {
                default: 'Total Interest Earned',
            },
            tab4GraphContributionOption1: {
                default: 'Starting Amount',
            },
            tab4GraphContributionOption2: {
                default: 'Total Contributions',
            },
            tab4GraphContributionOption3: {
                default: 'Total Interest Earned',
            },
        },
        data() {
            return {
                activeTab1: false,
                activeTab2: false,
                activeTab3: false,
                activeTab4: false,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
            };
        },
        mounted() {
            // Determine which tabs are visible and set the default active tab to the left most that is visible
            const firstActive = [this.isTab1Visible, this.isTab2Visible, this.isTab3Visible, this.isTab4Visible].findIndex(value => value === true);
            switch (firstActive) {
                case 0:
                    this.activeTab1 = true;
                    break;
                case 1:
                    this.activeTab2 = true;
                    break;
                case 2:
                    this.activeTab3 = true;
                    break;
                case 3:
                    this.activeTab4 = true;
                    break;
                default:
                    console.warn('no tabs visible, cannot set an active tab');
                    break;
            }
        },
        components: {
            Compound,
            Investment,
            Savings,
            Retirement,
            AdvertisingDisclosures,
        },
    };
</script>
<style src="../../assets/styles/v2/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
